<template>
	<div class="collapse collapse-item" :class="{ 'collapse--active': active }">
		<div
			class="collapse__header touchable"
			role="tab"
			:aria-expanded="active ? 'true' : 'false'"
			@click.prevent="toggle"
		>
			<slot name="collapse-header"></slot>
		</div>
		<transition
			enter-active-class="collapse-enter-active"
			leave-active-class="collapse-leave-active"
			@before-enter="beforeEnter"
			@enter="enter"
			@after-enter="afterEnter"
			@before-leave="beforeLeave"
			@leave="leave"
			@after-leave="afterLeave"
		>
			<div class="collapse-content" v-if="active">
				<div class="collapse-content-box">
					<slot name="collapse-body"></slot>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'Collapse',

	data() {
		return {
			active: false
		}
	},

	props: {
		opened: {
			type: Boolean,
			default: false
		}
	},

	created() {
		this.active = this.opened
	},

	methods: {
		toggle() {
			this.active = !this.active
			if (this.active) {
				this.$emit('collapse-open')
			}
		},

		open() {
			this.active = true
		},

		beforeEnter(element) {
			requestAnimationFrame(() => {
				if (!element.style.height) {
					element.style.height = '0px'
				}

				element.style.display = null
			})
		},

		enter(element) {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					element.style.height = `${element.scrollHeight}px`
				})
			})
		},

		afterEnter(element) {
			element.style.height = null
		},

		beforeLeave(element) {
			requestAnimationFrame(() => {
				if (!element.style.height) {
					element.style.height = `${element.offsetHeight}px`
				}
			})
		},

		leave(element) {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					element.style.height = '0px'
				})
			})
		},

		afterLeave(element) {
			element.style.height = null
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.collapse {
	margin-bottom: 2px;

	&__header {
		position: relative;
		cursor: pointer;
		padding-right: 32px;

		&::before {
			content: '';
			-moz-transition: all 0.2s;
			-o-transition: all 0.2s;
			-webkit-transition: all 0.2s;
			transition: all 0.2s;
			width: 6px;
			height: 6px;
			border: solid $white;
			border-width: 2px 2px 0 0;
			position: absolute;
			font-size: 0.4em;
			top: calc(50% - 0.4em);
			right: 24px;
			-ms-transform: rotate(135deg);
			transform: rotate(135deg);
		}
	}

	&--active {
		.collapse__header::before {
			-ms-transform: rotate(-45deg);
			transform: rotate(-45deg);
		}
	}
}

.collapse-enter-active,
.collapse-leave-active {
	overflow: hidden;
	transition: height 200ms linear;
}
</style>
